// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces/index';
import { Customer } from './customer';

export class GetOptionsResponseBookCodesEntry implements i.GetOptionsResponseBookCodesEntryInterface {
    key: string;
    value: string;

    static fromProto(proto: any): GetOptionsResponseBookCodesEntry {
        let m = new GetOptionsResponseBookCodesEntry();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: i.GetOptionsResponseBookCodesEntryInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.key === 'undefined' &&
            typeof this.value === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.key !== 'undefined') {toReturn['key'] = this.key;}
        if (typeof this.value !== 'undefined') {toReturn['value'] = this.value;}
        return toReturn;
    }
}

export class GetOptionsResponseContractTypesEntry implements i.GetOptionsResponseContractTypesEntryInterface {
    key: number;
    value: string;

    static fromProto(proto: any): GetOptionsResponseContractTypesEntry {
        let m = new GetOptionsResponseContractTypesEntry();
        m = Object.assign(m, proto);
        if (proto.key) {m.key = parseInt(proto.key, 10);}
        return m;
    }

    constructor(kwargs?: i.GetOptionsResponseContractTypesEntryInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.key === 'undefined' &&
            typeof this.value === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.key !== 'undefined') {toReturn['key'] = this.key;}
        if (typeof this.value !== 'undefined') {toReturn['value'] = this.value;}
        return toReturn;
    }
}

export class CreateCustomerRequest implements i.CreateCustomerRequestInterface {
    customer: Customer;

    static fromProto(proto: any): CreateCustomerRequest {
        let m = new CreateCustomerRequest();
        m = Object.assign(m, proto);
        if (proto.customer) {m.customer = Customer.fromProto(proto.customer);}
        return m;
    }

    constructor(kwargs?: i.CreateCustomerRequestInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.customer === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.customer !== 'undefined' && this.customer !== null) {toReturn['customer'] = 'toApiJson' in this.customer ? (this.customer as any).toApiJson() : this.customer;}
        return toReturn;
    }
}

export class CreateCustomerResponse implements i.CreateCustomerResponseInterface {
    internalCustomerId: string;

    static fromProto(proto: any): CreateCustomerResponse {
        let m = new CreateCustomerResponse();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: i.CreateCustomerResponseInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.internalCustomerId === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.internalCustomerId !== 'undefined') {toReturn['internalCustomerId'] = this.internalCustomerId;}
        return toReturn;
    }
}

export class GetOptionsResponseEditionsEntry implements i.GetOptionsResponseEditionsEntryInterface {
    key: string;
    value: string;

    static fromProto(proto: any): GetOptionsResponseEditionsEntry {
        let m = new GetOptionsResponseEditionsEntry();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: i.GetOptionsResponseEditionsEntryInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.key === 'undefined' &&
            typeof this.value === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.key !== 'undefined') {toReturn['key'] = this.key;}
        if (typeof this.value !== 'undefined') {toReturn['value'] = this.value;}
        return toReturn;
    }
}

export class GetOptionsRequest implements i.GetOptionsRequestInterface {

    static fromProto(proto: any): GetOptionsRequest {
        let m = new GetOptionsRequest();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: i.GetOptionsRequestInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        const toReturn: {
            [key: string]: any;
        } = {};
        
        return toReturn;
    }
}

export class GetOptionsResponse implements i.GetOptionsResponseInterface {
    bankNames: string[];
    bankAccountTypes: string[];
    paySources: {[key: string]: string};
    payMethods: {[key: string]: string};
    bookCodes: {[key: string]: string};
    editions: {[key: string]: string};
    contractTypes: {[key: string]: string};

    static fromProto(proto: any): GetOptionsResponse {
        let m = new GetOptionsResponse();
        m = Object.assign(m, proto);
        if (proto.paySources) {m.paySources = Object.keys(proto.paySources).reduce<any>((obj, k) => { obj[k] = proto.paySources[k]; return obj; }, {});}
        if (proto.payMethods) {m.payMethods = Object.keys(proto.payMethods).reduce<any>((obj, k) => { obj[k] = proto.payMethods[k]; return obj; }, {});}
        if (proto.bookCodes) {m.bookCodes = Object.keys(proto.bookCodes).reduce<any>((obj, k) => { obj[k] = proto.bookCodes[k]; return obj; }, {});}
        if (proto.editions) {m.editions = Object.keys(proto.editions).reduce<any>((obj, k) => { obj[k] = proto.editions[k]; return obj; }, {});}
        if (proto.contractTypes) {m.contractTypes = Object.keys(proto.contractTypes).reduce<any>((obj, k) => { obj[k] = proto.contractTypes[k]; return obj; }, {});}
        return m;
    }

    constructor(kwargs?: i.GetOptionsResponseInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.bankNames === 'undefined' &&
            typeof this.bankAccountTypes === 'undefined' &&
            typeof this.paySources === 'undefined' &&
            typeof this.payMethods === 'undefined' &&
            typeof this.bookCodes === 'undefined' &&
            typeof this.editions === 'undefined' &&
            typeof this.contractTypes === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.bankNames !== 'undefined') {toReturn['bankNames'] = this.bankNames;}
        if (typeof this.bankAccountTypes !== 'undefined') {toReturn['bankAccountTypes'] = this.bankAccountTypes;}
        if (typeof this.paySources !== 'undefined' && this.paySources !== null) {toReturn['paySources'] = 'toApiJson' in this.paySources ? (this.paySources as any).toApiJson() : this.paySources;}
        if (typeof this.payMethods !== 'undefined' && this.payMethods !== null) {toReturn['payMethods'] = 'toApiJson' in this.payMethods ? (this.payMethods as any).toApiJson() : this.payMethods;}
        if (typeof this.bookCodes !== 'undefined' && this.bookCodes !== null) {toReturn['bookCodes'] = 'toApiJson' in this.bookCodes ? (this.bookCodes as any).toApiJson() : this.bookCodes;}
        if (typeof this.editions !== 'undefined' && this.editions !== null) {toReturn['editions'] = 'toApiJson' in this.editions ? (this.editions as any).toApiJson() : this.editions;}
        if (typeof this.contractTypes !== 'undefined' && this.contractTypes !== null) {toReturn['contractTypes'] = 'toApiJson' in this.contractTypes ? (this.contractTypes as any).toApiJson() : this.contractTypes;}
        return toReturn;
    }
}

export class GetOptionsResponsePayMethodsEntry implements i.GetOptionsResponsePayMethodsEntryInterface {
    key: number;
    value: string;

    static fromProto(proto: any): GetOptionsResponsePayMethodsEntry {
        let m = new GetOptionsResponsePayMethodsEntry();
        m = Object.assign(m, proto);
        if (proto.key) {m.key = parseInt(proto.key, 10);}
        return m;
    }

    constructor(kwargs?: i.GetOptionsResponsePayMethodsEntryInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.key === 'undefined' &&
            typeof this.value === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.key !== 'undefined') {toReturn['key'] = this.key;}
        if (typeof this.value !== 'undefined') {toReturn['value'] = this.value;}
        return toReturn;
    }
}

export class GetOptionsResponsePaySourcesEntry implements i.GetOptionsResponsePaySourcesEntryInterface {
    key: number;
    value: string;

    static fromProto(proto: any): GetOptionsResponsePaySourcesEntry {
        let m = new GetOptionsResponsePaySourcesEntry();
        m = Object.assign(m, proto);
        if (proto.key) {m.key = parseInt(proto.key, 10);}
        return m;
    }

    constructor(kwargs?: i.GetOptionsResponsePaySourcesEntryInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.key === 'undefined' &&
            typeof this.value === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.key !== 'undefined') {toReturn['key'] = this.key;}
        if (typeof this.value !== 'undefined') {toReturn['value'] = this.value;}
        return toReturn;
    }
}

